export default "__VITE_ASSET__c654c068__"